module.exports = __webpack_public_path__ + "static/media/bg1.1d69e889.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/statics/images/bg1.jpg
// module id = ./src/statics/images/bg1.jpg
// module chunks = 0